exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/ranking/ranking.component.css
// module id = ../../../../../src/app/ranking/ranking.component.css
// module chunks = main